import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { SelectModule } from 'primeng/select';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { VehicleService } from '../vehicleService';
import { UserService } from '../../users/userService';
import { ListVehicleDto } from '../dto/listVehicleDto';
import { RestResponse } from '../../../shared/RestResponse';
import { Pagination } from '../../../shared/Pagination';

@Component({
  selector: 'app-list-vehicle',
  templateUrl: './list-vehicle.html',
  imports: [CommonModule, FormsModule, TableModule, ButtonModule, InputTextModule, TagModule, TooltipModule, SelectModule, ConfirmDialogModule]
})
export class ListVehicleComponent implements OnInit {
  vehicles: ListVehicleDto[] = [];
  search: string = '';
  searchTerm: string = '';
  active: boolean | null = null;
  driverId: number | null = null;
  drivers: any[] = [];

  constructor(
    private vehicleService: VehicleService,
    private userService: UserService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.loadVehicles();
    this.loadDrivers();
  }

  loadVehicles(): void {
    this.vehicleService.list(this.search, this.active, this.driverId, 1).subscribe((response: RestResponse<ListVehicleDto[]>) => {
      this.vehicles = response.data;
    });
  }

  loadDrivers(): void {
    // Assumindo que roleId 2 é para motoristas
    this.userService.list('', 1).subscribe({
      next: (response: RestResponse<any[]>) => {
        this.drivers = response.data;
      },
      error: (error) => {
        console.error('Erro ao carregar motoristas:', error);
        this.drivers = [];
      }
    });
  }

  onSearchChange(search: string): void {
    this.search = search;
    this.loadVehicles();
  }

  onActiveChange(active: boolean | null): void {
    this.active = active;
    this.loadVehicles();
  }

  onDriverChange(driverId: number | null): void {
    this.driverId = driverId;
    this.loadVehicles();
  }

  clearFilters(): void {
    this.search = '';
    this.searchTerm = '';
    this.active = null;
    this.driverId = null;
    this.loadVehicles();
  }


  editVehicle(id: number): void {
    this.router.navigate(['/vehicles/edit', id]);
  }

  deleteVehicle(id: number): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir este veículo?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.vehicleService.delete(id).subscribe({
          next: () => {
            this.loadVehicles();
          },
          error: (error) => {
            console.error('Erro ao excluir veículo:', error);
          }
        });
      }
    });
  }

  navigateToCreate(): void {
    this.router.navigate(['/vehicles/create']);
  }

}